export const HANDLE_INPUT_CHANGE = 'HANDLE_INPUT_CHANGE';
export const HANDLE_INPUT_BLUR = 'HANDLE_INPUT_BLUR';
export const TOGGLE_AGREE_TERMS = 'TOGGLE_AGREE_TERMS';
export const UPDATE_SUBMIT_STATE = 'UPDATE_SUBMIT_STATE';

export interface IInputState {
  isValid: boolean;
  value: string;
}

export interface IOnboardingState {
  agreeTerms: boolean;
  errorOnBlur: boolean;
  input: IInputState;
  submitted: boolean;
}

export interface IInputAction {
  payload: IInputState;
  type: typeof HANDLE_INPUT_CHANGE;
}

export interface IToggleAction {
  type: typeof TOGGLE_AGREE_TERMS;
}

export interface IBlurAction {
  type: typeof HANDLE_INPUT_BLUR;
}

export interface ISubmitAction {
  submit: boolean;
  type: typeof UPDATE_SUBMIT_STATE;
}

export type OnboardingActionTypes = IInputAction | IToggleAction | IBlurAction | ISubmitAction;

export const onboardingVariants = {
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  USER_SIGNUP: 'user_signup',
  ODDSCHECKER_PLUS_AD: 'oddschecker_plus_ad',
} as const;

export type OnboardingVariant = (typeof onboardingVariants)[keyof typeof onboardingVariants];

export const onboardingView = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type OnboardingView = (typeof onboardingView)[keyof typeof onboardingView];

// NGF-6334: the framework-coupled input that used to be a prop (resourcesUrl) now arrives through the
// CX runtime adapter (useConfig); responsive behaviour is CSS-only (no deviceType). So the shared
// component's props are purely the CMS-driven configuration.
export type OnboardingProps = {
  contentServer?: string;
  hasMarginTop?: boolean;
  initLabels?: Record<string, string>;
  variant?: OnboardingVariant;
  view?: OnboardingView;
};

/**
 * Action-data payload returned by the onboarding newsletter submit.
 */
export type OnboardingFetcherData = {
  fieldErrors?: Record<string, string>;
  message?: string;
  success: boolean;
};

/**
 * The minimal fetcher contract the onboarding store consumes — `{ data, state, submit }`. Each app
 * injects its own implementation as a prop (the proven sixth seam): RR7 narrows react-router's
 * `useFetcher`; atlas-astro implements it over native fetch (`useAstroNewsletterFetcher`). Defined
 * structurally HERE so the shared package stays react-router-free.
 */
export type OnboardingFetcher = {
  data: OnboardingFetcherData | undefined;
  state: 'idle' | 'loading' | 'submitting';
  submit: (formData: Record<string, string>, options: { action: string; method: string }) => void;
};
